import styled, { x } from '@xstyled/styled-components';
import React, { useEffect } from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { ThumbsPages, useThumbsStore } from './Store';
import { useSequenceStore } from '~/training/sequence/SequenceStore';

const Button = styled.buttonBox`
  width: 47%;
  padding: 10px 30px;
  text-align: center;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-weight: bold;
  border-width: 2px;
  background-color: white;
  color: black;
  border-color: greyMed;
  box-shadow: 0 4px 0 var(--color-grey-md);

  @media (max-width: md) {
    padding: 10px 0px;
  }

  &:focus {
    border: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }
  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 8px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
`;

export const Root = () => {
  const { page, setPage, toggle, open } = useThumbsStore();

  const { addBlocker, removeBlocker } = useSequenceStore();

  useEffect(() => {
    addBlocker('nextBtn');
    return () => removeBlocker('nextBtn');
  }, [open, page]);

  if (page !== ThumbsPages.Root) return null;

  return (
    <>
      <CloseButton type="close" onClick={() => toggle(false)} />
      <Flex as="fieldset" variant="list">
        <x.legend
          p="35px 25px 0px"
          maxW={{ _: '100%', md: '240px' }}
          fontSize="18px"
          textAlign="center"
          fontWeight="bold"
        >
          {t`Do you like the content on this page?`}
        </x.legend>
        <x.div display="flex" justifyContent="space-between">
          <Button onClick={() => setPage(ThumbsPages.FeedbackPositive)}>
            Yes 👍
          </Button>
          <Button onClick={() => setPage(ThumbsPages.FeedbackNegative)}>
            No 👎
          </Button>
        </x.div>
      </Flex>
    </>
  );
};
